var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{attrs:{"fluid":""}},[_c('h4',{staticStyle:{"font-size":"1rem","padding-top":"5px"}},[_vm._v("Time Table")]),_c('b-table',{attrs:{"responsive":true,"items":_vm.computedTableData,"fields":_vm.fields,"bordered":"","sticky-header":"310px","striped":"","small":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }